module.exports = __webpack_public_path__ + "static/media/mixrank2x.06167919.png";